/*
 * START_MODULE_CONTRACT
 *   PURPOSE: Merge Tailwind CSS classes with clsx + twMerge for conflict resolution
 *   INPUTS:  (...inputs: ClassValue[]) — any number of class name inputs
 *   OUTPUTS: string — merged class string with Tailwind conflicts resolved
 *   DEPENDS: none
 *   LINKS:   M-CN
 * END_MODULE_CONTRACT
 *
 * CHANGE_SUMMARY
 *   [2026-06-12] Added GRACE MODULE_CONTRACT — no behavior change
 */

import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  // --- MergeClasses ---
  return twMerge(clsx(inputs))
}
